import React from "react";
import { Button } from "@/components/Button";
import { PageModule } from "@/components/PageModule";

export const BundlesCTA = () => (
  <div className="bg-primary text-primary">
    <PageModule className="max-w-screen-md py-4">
      <div className="items-center justify-between text-center sm:flex sm:space-x-4">
        <p className="body flex flex-col space-y-2 text-white">
          <span className="title text-white">
            Go back to school with Dropps!
          </span>
          <span>Bundled up savings for school-approved cleaning.</span>
        </p>
        <Button
          component="a"
          href="pages/back-to-school-bundle"
          className="btn-secondary mt-4 sm:mt-0"
        >
          SHOP NOW
        </Button>
      </div>
    </PageModule>
  </div>
);
